export default [
  {
    path: '/about',
    name: 'about',
    meta: {
      hideTab:true
    },
    component: () => import('@/views/abouts/index.vue')
  }
]